module.exports = __webpack_public_path__ + "static/media/react.b7bf6c65.png";